import gql from 'graphql-tag';
import { Query } from 'core';

const PROFILE_SPACE_FIELDS = gql`
  fragment profileSpaceFields on Profile {
    id
    username
    inSpace {
      id
      whichTypes
      trialPeriodEnd
      hasPrivateProjectsSubscription
      spaceType
      content {
        id
        slug
      }
    }
  }
`;

export const PROFILE_SPACE = gql`
  ${PROFILE_SPACE_FIELDS}
  query ProfileSpaceBilling {
    loggedInUser {
      id
      profile {
        ...profileSpaceFields
      }
    }
  }
`;

export class ProfileSpaceQuery extends Query {
  static conf = {
    GQL: PROFILE_SPACE,
    resultPath: 'loggedInUser.profile',
  };
}
